export const FUEL_CARD_ID_KEY = 'id';
export const FUEL_CARD_ASSIGNED_TO_KEY = 'assignedTo';
export const FUEL_CARD_CARD_NUMBER_KEY = 'cardNumber';
export const FUEL_CARD_NOTE_KEY = 'note';
export const FUEL_CARD_VALID_UNTIL_KEY = 'validUntil';
export const FUEL_CARD_VEHIVLE_ID_KEY = 'vehicleId';
export const FUEL_CARD_PROVIDER_ID_KEY = 'fuelCardProviderId';
export const FUEL_CARD_IDENTIFIER_KEY = 'identifier';
export const FUEL_CARD_CUSTOMER_ID_KEY = 'customerId';
export const FUEL_CARD_CREATED_AT_KEY = 'createdAt';
export const FUEL_CARD_CREATED_BY_KEY = 'createdBy';
export const FUEL_CARD_MODIFIED_AT_KEY = 'modifiedAt';
export const FUEL_CARD_MODIFIED_BY_KEY = 'modifiedBy';
export const FUEL_CARD_DETAIL_KEY = 'detail';
export const FUEL_CARD_DELETED_AT_KEY = 'remove';

export const FUEL_CARD_TABLE_KEY = 'v1/fuel-card';
export const FUEL_CARD_TABLE_SETTINGS = 'fuel_card_2';
export const FUEL_CARD_QUERY_KEY = 'fuelCards';

export const TableSettingsKeys = {
  assignedTo: 'table_list.columns.fuelCards.assignedTo',
  customerId: 'table_list.columns.customerId',
  cardNumber: 'table_list.columns.fuelCards.cardNumber',
  identifier: 'table_list.columns.fuelCards.identifier',
  note: 'table_list.columns.fuelCards.note',
  vehicleId: 'table_list.columns.vehicleId',
  validUntil: 'table_list.columns.fuelCards.validUntil',
  fuelCardProviderId: 'table_list.columns.fuelCards.fuelCardProviderId',
  createdAt: 'table_list.columns.createdAt',
  createdBy: 'table_list.columns.createdBy',
  modifiedBy: 'table_list.columns.modifiedBy',
  modifiedAt: 'table_list.columns.modifiedAt',
};
